module.exports = {"140821100":"猗氏镇","140821101":"嵋阳镇","140821102":"临晋镇","140821103":"七级镇","140821104":"东张镇","140821105":"孙吉镇","140821106":"三管镇","140821107":"牛杜镇","140821108":"耽子镇","140821109":"角杯镇","140821200":"楚侯乡","140821201":"庙上乡","140821203":"北辛乡","140821204":"北景乡","140821402":"临猗县城市社区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140821.json
// module id = 422
// module chunks = 0